import * as React from "react";
import { useFeatureToggles } from "@grandvisionhq/state";
import { getCalculatedMaximumQuantity } from "@grandvisionhq/utils";
import { useAccessoriesEcommContext } from "../../../../../../../context/modules/EcommContent/AccessoriesEcommContent/context/AccessoriesEcommContext.js";
import { ProductQuantitySelector } from "../../../../../../../../components/ProductQuantitySelector/modules/EcommContent/components/ProductQuantitySelector/ProductQuantitySelector.js";
import { useProductData } from "../../../../../../../../../../context/context/product-context-hooks.js";
const AccessoriesQuantitySelector = () => {
  const { activeVariant } = useProductData();
  const { channelAvailability, stock } = activeVariant;
  const { setQuantity, quantity, maxOrderableQuantity } = useAccessoriesEcommContext();
  const { isAccessoriesPdpQuantitySelectorDisabled } = useFeatureToggles();
  const maxSelectableQuantity = getCalculatedMaximumQuantity(
    maxOrderableQuantity,
    stock.stockCount,
    stock.isAllowBackOrder
  );
  const onDecreaseQuantity = () => {
    setQuantity(quantity - 1);
  };
  const onIncreaseQuantity = () => {
    setQuantity(quantity + 1);
  };
  if (channelAvailability !== "ONLINE" || isAccessoriesPdpQuantitySelectorDisabled) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    ProductQuantitySelector,
    {
      className: "accessories-quantity-selector",
      quantity,
      maximumQuantity: maxSelectableQuantity,
      onDecreaseQuantity,
      onIncreaseQuantity
    }
  );
};
export {
  AccessoriesQuantitySelector
};
//# sourceMappingURL=AccessoriesQuantitySelector.js.map
